<script setup lang="ts">
import { computed, useSlots } from 'vue'

import { BoxComponent, FlexComponent } from '@/ui-library'

const props = withDefaults(defineProps<{ childrenWidth?: string; name?: string }>(), { childrenWidth: '50%', name: undefined })
const slots = useSlots()

const modelValue = defineModel<number | string | boolean>('modelValue')
const childrenWidth = computed(() => `0 1 calc(${props.childrenWidth} - 8px)`)
</script>

<template>
  <div>
    <div v-if="slots.header">
      <BoxComponent :mb="8">
        <slot name="header" />
      </BoxComponent>
    </div>
    <el-radio-group v-model="modelValue" size="large" :name="name">
      <FlexComponent class="radio-group" :gap="8" wrap="wrap">
        <slot />
      </FlexComponent>
    </el-radio-group>
  </div>
</template>

<style scoped lang="scss">
.radio-group {
  margin-right: -8px;
}
:deep(.radio-group .el-radio-button) {
  flex: v-bind(childrenWidth);
}
</style>
